import { render, staticRenderFns } from "./BannerForm.vue?vue&type=template&id=6b61511f&scoped=true&"
import script from "./BannerForm.vue?vue&type=script&lang=js&"
export * from "./BannerForm.vue?vue&type=script&lang=js&"
import style0 from "./BannerForm.vue?vue&type=style&index=0&id=6b61511f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b61511f",
  null
  
)

export default component.exports